import React, { Component } from 'react';
import './ValuePropositionComponent.css';
import Step1 from './Step1/Step1';
import Step2 from './Step2/Step2';
import Step3 from './Step3/Step3';
import Step4 from './Step4/Step4';
import Result from './Result/Result'

class ValuePropositionComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groupStepState: 1,
            disableNextState: false,
            tabStep: 0
        };
    }

    groupStateNext = () => {
        this.setState({ groupStepState: this.state.groupStepState + 1 })
    }

    groupStateBack = () => {
        this.setState({ groupStepState: this.state.groupStepState - 1 })
    }
    disableNextModal = () => {
        this.setState({ disableNextState: !this.state.disableNextState })
    }
    onTabChange=(number)=>{
        if(number!==this.state.tabStep){
            this.setState({tabStep: number})
        }
    }

    componentWillMount() {
        localStorage.setItem("openedTool", this.props.projectId);
    }
    
    render() {
        return (
            <div className='projects-content challenge-statement-content'>
                <div>
                    {this.state.groupStepState === 1 &&
                        <Step1
                            projectId={this.props.projectId}
                            getCustomerSegment={this.props.getCustomerSegment}
                            getCompete={this.props.getCompete}
                            compete={this.props.compete}
                            positioningStatement={this.props.positioningStatement}
                            getPositioningStatement={this.props.getPositioningStatement}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            getValueProposition={this.props.getValueProposition}
                            valueProposition={this.props.valueProposition}
                            createValueProposition={this.props.createValueProposition}
                            editValueProposition={this.props.editValueProposition}
                            groupStepState={this.state.groupStepState}
                            groupStateNext={this.groupStateNext}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.groupStepState === 2 &&
                        <Step2
                            projectId={this.props.projectId}
                            getCustomerSegment={this.props.getCustomerSegment}
                            getCompete={this.props.getCompete}
                            compete={this.props.compete}
                            positioningStatement={this.props.positioningStatement}
                            getPositioningStatement={this.props.getPositioningStatement}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            getValueProposition={this.props.getValueProposition}
                            valueProposition={this.props.valueProposition}
                            editValueProposition={this.props.editValueProposition}
                            groupStepState={this.state.groupStepState}
                            groupStateNext={this.groupStateNext}
                            groupStateBack={this.groupStateBack}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.groupStepState === 3 &&
                        <Step3
                            projectId={this.props.projectId}
                            getCustomerSegment={this.props.getCustomerSegment}
                            getCompete={this.props.getCompete}
                            compete={this.props.compete}
                            positioningStatement={this.props.positioningStatement}
                            getPositioningStatement={this.props.getPositioningStatement}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            getValueProposition={this.props.getValueProposition}
                            valueProposition={this.props.valueProposition}
                            editValueProposition={this.props.editValueProposition}
                            groupStepState={this.state.groupStepState}
                            groupStateNext={this.groupStateNext}
                            groupStateBack={this.groupStateBack}
                            getInfluencerMapGroups={this.props.getInfluencerMapGroups}
                            getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                            addInfluencerMapGroupsData={this.props.addInfluencerMapGroupsData}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.groupStepState === 4 &&
                        <Step4
                            projectId={this.props.projectId}
                            getCustomerSegment={this.props.getCustomerSegment}
                            getCompete={this.props.getCompete}
                            compete={this.props.compete}
                            positioningStatement={this.props.positioningStatement}
                            getPositioningStatement={this.props.getPositioningStatement}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            getValueProposition={this.props.getValueProposition}
                            valueProposition={this.props.valueProposition}
                            editValueProposition={this.props.editValueProposition}
                            groupStepState={this.state.groupStepState}
                            groupStateNext={this.groupStateNext}
                            groupStateBack={this.groupStateBack}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.groupStepState === 5 &&
                        <Result
                            projectId={this.props.projectId}
                            getCustomerSegment={this.props.getCustomerSegment}
                            getCompete={this.props.getCompete}
                            compete={this.props.compete}
                            positioningStatement={this.props.positioningStatement}
                            getPositioningStatement={this.props.getPositioningStatement}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            getValueProposition={this.props.getValueProposition}
                            valueProposition={this.props.valueProposition}
                            editValueProposition={this.props.editValueProposition}
                            groupStepState={this.state.groupStepState}
                            groupStateNext={this.groupStateNext}
                            groupStateBack={this.groupStateBack}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }

                </div>
            </div>
        )
    }
}

export default (ValuePropositionComponent);



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/ValuePropositionComponent.jsx